import { Message } from 'element-ui';
export const responseError = (res) => {
    var _a;
    return Message.error(((_a = res === null || res === void 0 ? void 0 : res.response) === null || _a === void 0 ? void 0 : _a.describe) || (res === null || res === void 0 ? void 0 : res.message));
};
